import { useState, useEffect } from "react";

import { Button, ArrowButton, InfoPanel } from "@king-ict/eupisi-ui/components";
import { hrDate } from "@king-ict/eupisi-ui/utils";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router";

import { getAndCheckInstitutionRequest } from "../../api/nisooApi";
import StaticField from "../../components/StaticField";
import { Institution, institutionInitial } from "../../models/Institution";
import { RoleEnum } from "../../models/User/RoleEnum";
import { useGetUserSessionQuery } from "../../queries/userQuery";
import { institutionEditRoute, dashboardRoute, institutionListRoute } from "../../routes/routes";
import styles from "./Institution.module.scss";
import InstitutionPanel from "./InstitutionPanel";

export default function InstitutionDetails() {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();

  const [institution, setInstitution] = useState<Institution>(institutionInitial);
  const { data: userSession } = useGetUserSessionQuery();

  useEffect(() => {
    if (!userSession) {
      return;
    }
    var institutionId = (location.state as any)?.id;

    const fetchInstitution = async (id: number) => {
      var results = await getAndCheckInstitutionRequest(id);
      setInstitution(results);
    }

    if (!institutionId) {
      institutionId = userSession.institutionId!;
    }
    window.scrollTo(0, 0);
    fetchInstitution(institutionId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userSession])

  var updateFromOib = institution.addressFromOib || institution.nameFromOib || institution.townFromOib;
  var updateFromOibAlertRow;

  if (updateFromOib) {
    updateFromOibAlertRow =
      <Row className={styles.oibDataAlertRow}>
        <Col md={12}>
          <InfoPanel
            color="warning"
            message={t("institution.changesFromOibData")}
          />
        </Col>
      </Row>
  }

  const onEditInstitution = () => {
    if (institution) {
      history.push(institutionEditRoute(), { id: institution.id });
    }
  };

  const onBackToRequestList = () => {
    if (userSession) {
      if (userSession.roleId === RoleEnum.InstitutionAdmin || userSession.roleId === RoleEnum.InstitutionDirector) {
        history.push(dashboardRoute());
      }
      else {
        history.push(institutionListRoute());
      }
    }
  };

  var editButton;


  if (userSession && (userSession.roleId === RoleEnum.InstitutionAdmin || userSession.roleId === RoleEnum.InstitutionDirector || userSession.roleId === RoleEnum.CASAdmin
    || userSession.roleId === RoleEnum.Helpdesk || userSession.roleId === RoleEnum.CASManager)) {
    editButton =
      <Col md={6}>
        <Button onClick={onEditInstitution} className={styles.actionButton}>
          {t("common.edit")}
        </Button>
      </Col>
  }

  return (
    <>
      <Row>
        <Col md={6}>
          {userSession && userSession.roleId !== RoleEnum.InstitutionAdmin && userSession.roleId !== RoleEnum.InstitutionDirector &&
            <>
              <ArrowButton
                backwards
                ariaLabel=""
                onClick={onBackToRequestList}
              />
              <span className={styles.backButtonCaption}>
                {t("common.returnToInstitutionList")}
              </span>
            </>
          }
        </Col>


        {editButton}
      </Row>
      {updateFromOibAlertRow}
      <Row className={styles.dataRow}>
        <Col md={4}>
          <StaticField
            label={t("common.lastModifiedDate")}
            value={hrDate(institution.lastModified)}
          />
        </Col>
        <Col md={4}>
          <StaticField
            label={t("common.user")}
            value={institution.user}
          />
        </Col>
      </Row>

      <InstitutionPanel institution={institution} />

    </>
  );
}
